<template>
  <div class="tc-other">
    <div class="tc-top">
      <img src="./img/top.png" alt />
    </div>
    <div class="tc-product tc-product3">
      <div class="tc-product-top">
        <div class="product-top-size">
          <img src="./img/product3-1.png" alt />
        </div>
        <div class="product-top-size">
          <img src="./img/product3-2.png" alt />
        </div>
        <div class="product-top-size">
          <img src="./img/product3-3.png" alt />
        </div>
      </div>
      <!-- 平安新一贷 -->
      <div class="tc-product-but" @click="goXinyidai">
        <img src="./img/but.png" alt />
      </div>
      <div class="product-00">
        <img src="./img/00.png" alt="">
      </div>
    </div>
    
    <div class="tc-product">
      <div class="tc-product-top">
        <div class="product-top-size">
          <img src="./img/product1-1.png" alt />
        </div>
        <div class="product-top-size">
          <img src="./img/product1-2.png" alt />
        </div>
        <div class="product-top-size">
          <img src="./img/product1-3.png" alt />
        </div>
      </div>
      <div class="tc-product-bot">
        <img src="./img/product1-4.png" alt />
      </div>
      <!-- 众安尊享e生 -->
      <div class="tc-product-but" @click="goProduct(34)">
        <img src="./img/but.png" alt />
      </div>
      <div class="product-01">
        <img src="./img/00.png" alt="">
      </div>
    </div>
    <div class="tc-product tc-product2">
      <div class="tc-product-t">
        <img src="./img/product2-1.png" alt />
      </div>
      <div class="tc-product-top">
        <div class="product-top-size product2-size">
          <img src="./img/product2-2.png" alt />
        </div>
        <div class="product-top-size product2-size">
          <img src="./img/product2-3.png" alt />
        </div>
      </div>
      <!-- 平安终生防癌 -->
      <div class="tc-product-but" @click="goProduct(88)">
        <img src="./img/but.png" alt />
      </div>
    </div>
    <div class="tc-pro-more">
      <img src="./img/more.png" alt="">
    </div>
    <div class="tc-pro-more-but" @click.prevent="goMoreProduct">
      <img src="./img/more-but.png" alt="">
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{}
  },
  methods:{
    //众安尊享e生
    goProduct(id){
      this.$router.push({
        path:'/sharePage',
        query:{productid:id}
      })
    },
    //平安终生防癌
    // goPingan(){

    // },
    //平安新一贷
    goXinyidai(){
      this.$router.replace({path:'/lufax',query:{postcode:'d215ddf5f4f3d956159a54d6160f6654',biztag:'13866666666'}})
    },
    // 查看更多产品
    goMoreProduct(){
      this.$router.push('/productTC')
    }
  }
}
</script>

<style lang="less" scoped>
.tc-other {
  width: 375px;
  height: 2135px;
  background: url("./img/bg.png") no-repeat;
  background-size: 100% 100%;
  overflow: hidden;
  img {
    width: 100%;
  }
  .tc-top {
    width: 320px;
    height: 105px;
    margin: 42px auto auto auto;
  }
  .tc-product {
    width: 350px;
    height: 517px;
    margin: 17px auto auto auto;
    background: url("./img/product1.png") no-repeat;
    background-size: 100% 100%;
    .tc-product-top {
      display: flex;
      justify-content: center;
      .product-top-size {
        width: 105px;
        height: 143px;
        margin-top: 95px;
        &:not(:first-child) {
          padding-left: 7px;
        }
      }
    }
    .tc-product-bot {
      width: 329px;
      height: 118px;
      margin: 28px auto auto auto;
    }
    .tc-product-but {
      width: 265px;
      height: 55px;
      margin: 28px auto auto auto;
    }
  }
  .tc-product2{
    height: 628px;
    margin: 0 auto auto auto;
    background: url("./img/product2.png") no-repeat;
    background-size: 100% 100%;
    overflow: hidden;
    .tc-product-t{
      width: 317px;
      height: 299px;
      margin: 113px auto auto auto ;
    }
    .product2-size{
      width: 122px;
      height: 74px !important;
      margin-top: 13px !important;
      &:nth-child(2){
        padding-left: 22px !important;
      }
    }
  }
  .tc-product3{
    height: 356px;
    margin: 308px auto auto auto;
    background: url("./img/product3.png") no-repeat;
    background-size: 100% 100%;
  }
  .product-00,.product-01{
    width: 268px;
    height: 70px;
    margin: 16px auto auto auto;
    img{
      width: 100%;
      height: 100%;
    }
  }
  .product-01{
    margin: 24px auto auto auto;
  }
  .tc-pro-more{
    width: 41px;
    height: 55px;
    margin: 12px auto auto auto;
  }
  .tc-pro-more-but{
    width: 312px;
    height: 66px;
    margin: 14px auto auto auto;
  }
}
</style>